import { SoundEffect } from "../music/SoundEffect";

export const playConnectionEffect = () => {
  new SoundEffect("start.mp3");
};

export const playSoundEffect = (url: string) => {
  new SoundEffect(url);
};

export const play3DSoundEffect = (
  uuid: string,
  url: string,
  x: number,
  y: number,
  z: number,
) => {
  new SoundEffect(url).applyOrientation(uuid, x, y, z);
};
